import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { scenarioItems } from "@/mocks/home";

export default function Scenarios() {
  return (
    <section id="scenes" className="w-full bg-background-100 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="使用场景"
            title="不同场景，都有合适的看法"
            desc="在线观看不只是把影片放出来，更取决于你在什么时间、用什么设备、想获得怎样的节奏。下面按最常见的四类场景整理了具体建议。"
          />
        </Reveal>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {scenarioItems.map((item, index) => (
            <Reveal key={item.id} delay={index * 80}>
              <article className="h-full rounded-lg bg-background-50 border border-background-200 p-5 hover:border-primary-300 transition-colors">
                <span className="w-11 h-11 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 mb-4">
                  <i className={`${item.icon} text-xl`}></i>
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}